/* eslint-disable no-undef */
import { StoryWidgetLazy } from './storyWidgetLazy';

const props = [];

export const StorySectionWidgetDirective = reactDirective => reactDirective(StoryWidgetLazy, props);
StorySectionWidgetDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('storySectionWidget', StorySectionWidgetDirective);
